export const URL = {
  BASE: "http://localhost:5173/",
  API: "http://api-server/",
};

export const MODAL_TYPE = {
  NONE: "none",
  CARD_EDIT: "cardEdit",
  CARD_DETAIL: "cardDetail",
};

export const STORAGE_KEY = {
  TOKEN: "token",
};

export const STATUS_CODE = {
  400: "400",
  401: "401",
  404: "404",
  500: "500",
  504: "504",
};

export const DETAIL_CODE = {
  700: "700",
};

export const SEARCH_PARAMS_KEY = {
  SEARCH: "search",
  MENU: "menu",
  FUNNEL_STEPS: "funnel-steps",
};

export const DRAWER_MENU = {
  ALL: "all",
  CHANGE_BACKGROUND: "change-background",
};
